import api from './api';

export const getCoupons = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await api.get(`/coupons?${queryParams}`);
  return response.data;
};

export const getCouponById = async (id) => {
  const response = await api.get(`/coupons/${id}`);
  return response.data;
};

export const createCoupon = async (data) => {
  const response = await api.post('/coupons', data);
  return response.data;
};

export const updateCoupon = async (id, data) => {
  const response = await api.put(`/coupons/${id}`, data);
  return response.data;
};

export const deleteCoupon = async (id) => {
  const response = await api.delete(`/coupons/${id}`);
  return response.data;
};

export const getCouponStats = async () => {
  const response = await api.get('/coupons/stats');
  return response.data;
};

export const verifyCoupon = async (code, total, serviceIds = []) => {
  const response = await api.get(`/coupons/verify/${code}?total=${total}&service_ids=${serviceIds.join(',')}`);
  return response.data;
};
